<template functional lang="pug">
router-view
</template>

<script>
export default {
  name: "App",
  components: {}
};
</script>

<style lang="scss">
// @import "@/assets/styles/app.scss";
</style>
